/*
 * AUTO OBRAZY — V305 čeština pre texty napísané priamo v téme.
 *
 * Načítava sa iba na /cs/ (request.locale = cs). Produkty, kolekcie a menu
 * majú vlastné preklady v Shopify; tento súbor rieši texty, ktoré sú
 * natvrdo v Liquid/JS (košík, customizéry, kalkulačka, hlavička…).
 *
 * Ako to funguje:
 *  - textové uzly a vybrané atribúty sa prekladajú podľa slovníka hneď,
 *    ako sa objavia v DOM (MutationObserver už od <head>),
 *  - `textContent` čítaný skriptmi vracia PÔVODNÝ slovenský text, takže
 *    logika témy (porovnania, regexy) sa nemení a nevzniká slučka,
 *  - ceny v € dostanú orientačnú sumu v Kč (platba stále prebieha v EUR).
 */
(function () {
  'use strict';
  if (window.__aoI18nCs) return;
  window.__aoI18nCs = true;

  var DICT = window.AO_CS_DICT || {};

  /* ---------- slovník ---------- */
  function norm(s) { return String(s).replace(/[\s ]+/g, ' ').trim(); }
  var exact = Object.create(null);
  var patterns = [];
  Object.keys(DICT).forEach(function (k) {
    var key = norm(k);
    if (key.indexOf('{x}') !== -1) {
      var parts = key.split('{x}').map(function (p) { return p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      patterns.push({ re: new RegExp('^' + parts.join('(.+?)') + '$'), out: norm(DICT[k]) });
    } else {
      exact[key] = DICT[k];
    }
  });
  patterns.sort(function (a, b) { return b.re.source.length - a.re.source.length; });

  function tr(src) {
    var s = String(src);
    if (!/[A-Za-zÀ-ž]/.test(s)) return null;
    var key = norm(s);
    if (!key) return null;
    var out = exact[key];
    if (out == null) {
      for (var i = 0; i < patterns.length; i++) {
        var m = key.match(patterns[i].re);
        if (m) {
          var j = 1;
          out = patterns[i].out.replace(/\{x\}/g, function () { return m[j++] || ''; });
          break;
        }
      }
    }
    if (out == null) {
      /* V305b: text s cenou uprostred („Iba +1,99 €“, „Ešte 12 € do …“) —
         preložia sa časti pred a za cenou, cena ostane. */
      var pm = key.match(/\d[\d .]*(?:,\d{1,2})?\s?€/);
      if (pm) {
        var left = key.slice(0, pm.index), right = key.slice(pm.index + pm[0].length);
        var tl = left.trim() ? tr(left) : null, trr = right.trim() ? tr(right) : null;
        if (tl != null || trr != null) out = (tl != null ? tl : left) + pm[0] + (trr != null ? trr : right);
      }
    }
    if (out == null || out === key) return null;
    var lead = s.match(/^[\s ]*/)[0], tail = s.match(/[\s ]*$/)[0];
    return lead + out + tail;
  }
  window.AO_T = function (s) { var t = tr(s); return t == null ? s : t.trim(); };

  /* ---------- textContent vracia slovenský originál ---------- */
  var desc = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');
  var translatedCount = 0;
  if (desc && desc.get && desc.set) {
    Object.defineProperty(Node.prototype, 'textContent', {
      configurable: true,
      enumerable: desc.enumerable,
      get: function () {
        if (!translatedCount) return desc.get.call(this);
        var t = this.nodeType;
        if (t === 3) return this.__aoOut === this.data && this.__aoSrc != null ? this.__aoSrc : this.data;
        if (t !== 1 && t !== 11) return desc.get.call(this);
        var w = document.createTreeWalker(this, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_CDATA_SECTION);
        var out = '', n;
        while ((n = w.nextNode())) {
          if (n.parentNode && n.parentNode.__aoCzkTag) continue;
          out += (n.__aoOut === n.data && n.__aoSrc != null) ? n.__aoSrc : n.data;
        }
        return out;
      },
      set: function (v) { desc.set.call(this, v); }
    });
  }

  /* ---------- prekladanie DOM ---------- */
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1, TEMPLATE: 1, SVG: 1, svg: 1 };
  function skipEl(el) {
    for (var e = el; e && e.nodeType === 1; e = e.parentNode) {
      if (SKIP[e.nodeName]) return true;
      if (e.isContentEditable) return true;
      if (e.hasAttribute && e.hasAttribute('data-ao-i18n-skip')) return true;
    }
    return false;
  }
  function doText(n) {
    if (n.__aoOut === n.data) return;
    var p = n.parentNode;
    if (!p || p.nodeType !== 1 || skipEl(p)) return;
    var t = tr(n.data);
    if (t == null) return;
    n.__aoSrc = n.data;
    n.__aoOut = t;
    n.data = t;
    translatedCount++;
  }
  var ATTRS = ['placeholder', 'aria-label', 'title', 'alt', 'data-ao-home-note'];
  function doAttrs(el) {
    if (skipEl(el)) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i];
      if (!el.hasAttribute(a)) continue;
      var v = el.getAttribute(a);
      var mark = '__aoA_' + a;
      if (el[mark] === v) continue;
      var t = tr(v);
      if (t == null) continue;
      el[mark] = t;
      el.setAttribute(a, t);
    }
    if (el.nodeName === 'INPUT' && /^(submit|button)$/i.test(el.type || '') && el.value) {
      if (el.__aoV !== el.value) { var tv = tr(el.value); if (tv != null) { el.__aoV = tv; el.value = tv; } }
    }
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { doText(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    if (root.nodeType === 1) { if (SKIP[root.nodeName]) return; doAttrs(root); }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeType === 1 && SKIP[n.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) doText(n); else doAttrs(n);
    }
  }

  var pending = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var list = pending; pending = [];
    for (var i = 0; i < list.length; i++) walk(list[i]);
    czkSoon();
  }
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'childList') {
        for (var j = 0; j < r.addedNodes.length; j++) {
          var a = r.addedNodes[j];
          if (a.nodeType === 3) doText(a);
          else if (a.nodeType === 1) walk(a);
        }
      } else if (r.type === 'characterData') {
        doText(r.target);
      } else if (r.type === 'attributes' && r.target.nodeType === 1) {
        doAttrs(r.target);
      }
    }
    czkSoon();
  });
  mo.observe(document.documentElement, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ATTRS
  });
  walk(document.documentElement);

  /* Okná prehliadača (confirm/alert) */
  ['alert', 'confirm'].forEach(function (fn) {
    var orig = window[fn];
    if (typeof orig !== 'function') return;
    window[fn] = function (msg) { return orig.call(window, window.AO_T(msg == null ? '' : msg)); };
  });

  function titleFix() {
    var t = tr(document.title);
    if (t != null) document.title = t;
  }

  /* ---------- orientačná cena v Kč ---------- */
  var FALLBACK_RATE = 24.37;
  var rate = FALLBACK_RATE;
  try {
    var c = JSON.parse(localStorage.getItem('ao_czk_rate') || 'null');
    if (c && c.r > 15 && c.r < 40) rate = c.r;
    if (!c || Date.now() - c.t > 12 * 3600 * 1000) {
      fetch('https://api.frankfurter.app/latest?from=EUR&to=CZK', { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var r = j && j.rates && Number(j.rates.CZK);
          if (r > 15 && r < 40) {
            rate = r;
            try { localStorage.setItem('ao_czk_rate', JSON.stringify({ r: r, t: Date.now() })); } catch (e) {}
            czkSoon();
          }
        })
        .catch(function () {});
    }
  } catch (e) {}

  var PRICE_TARGETS = [
    { sel: '.ao-price__current', mode: 'inline', note: true },
    { sel: '.vc-price > strong', mode: 'inline' },
    { sel: '#summary_price', mode: 'inline' },
    { sel: '#vehicle_purchase_price', mode: 'inline' },
    { sel: '.ao-sticky-cart__price', mode: 'inline' },
    { sel: '[data-ao-grand]', mode: 'line' }
  ];
  function eurValue(text) {
    var m = String(text || '').replace(/ /g, ' ').match(/(\d[\d .]*)(?:,(\d{1,2}))?\s*€/);
    if (!m) return NaN;
    return Number(m[1].replace(/[ .]/g, '') + '.' + (m[2] || '0'));
  }
  function czkText(eur) {
    var k = Math.round(eur * rate);
    return '≈ ' + String(k).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč';
  }
  var czkTimer = 0;
  function czkSoon() {
    if (czkTimer) return;
    czkTimer = requestAnimationFrame(function () { czkTimer = 0; paintCzk(); titleFix(); });
  }
  function paintCzk() {
    PRICE_TARGETS.forEach(function (t) {
      document.querySelectorAll(t.sel).forEach(function (el) {
        if (el.closest('[data-ao-globe-module]')) return;
        var eur = eurValue(desc.get.call(el));
        var tag = el.__aoCzk;
        if (tag && !tag.isConnected) tag = null;
        if (!(eur > 0)) { if (tag) tag.hidden = true; return; }
        if (!tag) {
          if (t.mode === 'line') {
            var row = el.closest('.ao-totals__row') || el.parentNode;
            tag = document.createElement('p');
            tag.className = 'ao-czk-line';
            row.parentNode.insertBefore(tag, row.nextSibling);
          } else {
            tag = document.createElement('span');
            tag.className = 'ao-czk';
            el.parentNode.insertBefore(tag, el.nextSibling);
          }
          tag.setAttribute('data-ao-i18n-skip', '');
          tag.__aoCzkTag = true;
          el.__aoCzk = tag;
          if (t.note && !document.querySelector('.ao-czk-note')) {
            var box = el.closest('.ao-price') || el.parentNode;
            var note = document.createElement('p');
            note.className = 'ao-czk-note';
            note.setAttribute('data-ao-i18n-skip', '');
            note.textContent = 'Cena v Kč je orientační podle aktuálního kurzu. Platba proběhne v eurech (EUR).';
            box.parentNode.insertBefore(note, box.nextSibling);
          }
        }
        var txt = t.mode === 'line' ? czkText(eur) + ' · platba proběhne v EUR' : czkText(eur);
        if (desc.get.call(tag) !== txt) tag.textContent = txt;
        tag.hidden = false;
      });
    });
    paintGenericCzk();
  }

  /* V305b: Kč aj pri všetkých ostatných cenách (karty produktov, košík,
     súvisiace produkty…). Berie sa iba prvok, ktorého celý text je cena
     („24,99 €“ alebo „od 24,99 €“); prečiarknuté ceny, zľavy a sumy vo vete
     sa preskakujú. Text Kč je pre skripty témy neviditeľný (textContent). */
  var PRICE_ONLY = /^(?:od\s+)?\d[\d\s.]*(?:,\d{1,2})?\s*€$/i;
  var NO_CZK = 's, del, strike, button, [data-ao-reward-bar], [data-ao-reward-text], .ao-header-shipping, header, [data-ao-globe-module], [data-ao-i18n-skip], button[name="checkout"], .ao-globe-checkout-button, [data-ao-checkout], #checkout, option, select, script, style, title, head';
  var genericAt = 0;
  function paintGenericCzk() {
    var now = Date.now();
    if (now - genericAt < 200) { setTimeout(czkSoon, 220); return; }
    genericAt = now;
    if (!document.body) return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.data.indexOf('€') !== -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; }
    });
    var seen = [], n;
    while ((n = w.nextNode())) {
      var el = n.parentNode;
      if (!el || el.nodeType !== 1 || el.__aoCzkTag || seen.indexOf(el) !== -1) continue;
      seen.push(el);
    }
    seen.forEach(function (el) {
      if (el.__aoCzk && el.__aoCzk.isConnected && !el.__aoGeneric) return;
      if (el.closest(NO_CZK)) return;
      var raw = String(desc.get.call(el)).replace(/[\s ]+/g, ' ').trim();
      var tag = el.__aoCzk;
      if (tag && !tag.isConnected) tag = null;
      if (!PRICE_ONLY.test(raw)) { if (tag) tag.hidden = true; return; }
      var eur = eurValue(raw);
      if (!(eur > 0)) { if (tag) tag.hidden = true; return; }
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'ao-czk';
        tag.setAttribute('data-ao-i18n-skip', '');
        tag.__aoCzkTag = true;
        var after = el;
        var nx = el.nextElementSibling;
        if (nx && /^(S|DEL|STRIKE)$/.test(nx.nodeName)) after = nx;
        after.parentNode.insertBefore(tag, after.nextSibling);
        el.__aoCzk = tag;
        el.__aoGeneric = true;
      }
      var txt = czkText(eur);
      if (desc.get.call(tag) !== txt) tag.textContent = txt;
      if (tag.hidden) tag.hidden = false;
    });
  }
  var st = document.createElement('style');
  st.textContent = '.ao-czk{display:inline-block;margin-left:.45em;font-size:.72em;font-weight:500;opacity:.68;white-space:nowrap;vertical-align:baseline}'
    + '.ao-czk-line{margin:2px 0 0;text-align:right;font-size:11.5px;opacity:.7}'
    + '.ao-czk-note{margin:4px 0 0;font-size:11.5px;line-height:1.35;opacity:.65}';
  (document.head || document.documentElement).appendChild(st);

  /* Strážca dopravy (ao-cart-benefits.js) rozpoznáva voľby podľa slovenských
     slov. Ak widget Packeta/Globe na /cs/ píše po česky, české slová mu pred
     porovnaním premeníme na slovenské. Logika strážcu sa nemení. */
  var CZ2SK = [
    [/doručení domů/g, 'doručenie domov'], [/doručení na adresu/g, 'doručenie na adresu'],
    [/kurýr/g, 'kuriér'], [/výdejní míst/g, 'výdajné miest'], [/zásilkovna/g, 'packeta'],
    [/změnit/g, 'zmeniť'], [/vybrat/g, 'vybrať'], [/potvrdit/g, 'potvrdiť']
  ];
  function patchGuard() {
    var g = window.AOGlobeGuard;
    if (!g || g.__aoCs) return !!g;
    var orig = g.normalize;
    if (typeof orig !== 'function') return true;
    g.normalize = function (v) {
      var s = orig.call(g, v);
      for (var i = 0; i < CZ2SK.length; i++) s = s.replace(CZ2SK[i][0], CZ2SK[i][1]);
      return s;
    };
    g.__aoCs = true;
    try { g.scheduleApply && g.scheduleApply(); } catch (e) {}
    return true;
  }
  (function waitGuard(n) {
    if (patchGuard() || n > 60) return;
    setTimeout(function () { waitGuard(n + 1); }, 250);
  })(0);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { walk(document.body); czkSoon(); });
  else czkSoon();
})();
